/* TDA Dior drawer — verified replacement set 2026-08-05-v9 */
(() => {
  const SELECTOR = ".tda-rolex-desktop-menu";
  const DESKTOP_QUERY = "(min-width: 990px)";
  const CLOSE_DURATION = 660;
  const PANEL_DURATION = 660;
  const PANEL_REVEAL_DELAY = 680;

  function initialiseLvMenu(root = document) {
    root.querySelectorAll(SELECTOR).forEach((menu) => {
      if (menu.dataset.tdaMenuReady === "true") return;

      menu.dataset.tdaMenuReady = "true";

      const toggle = menu.querySelector(
        ":scope > .tda-rolex-desktop-menu__toggle",
      );
      const overlay = menu.querySelector(
        ":scope > .tda-rolex-desktop-menu__overlay",
      );
      const sheet = menu.querySelector(".tda-rolex-desktop-menu__sheet");
      const mainView = menu.querySelector("[data-tda-menu-main-view]");
      const rightColumn = menu.querySelector(".tda-rolex-desktop-menu__right");
      const panelButtons = Array.from(
        menu.querySelectorAll("[data-tda-menu-open-panel]"),
      );
      const backButtons = Array.from(
        menu.querySelectorAll("[data-tda-menu-back]"),
      );
      const panels = Array.from(menu.querySelectorAll("[data-tda-menu-panel]"));
      const submenus = Array.from(
        menu.querySelectorAll("[data-tda-menu-submenu]"),
      );

      if (!toggle || !overlay || !sheet) return;

      /*
       * Keep the desktop drawer outside every sticky/transformed header.
       * Otherwise a fixed overlay is constrained by that header and can lock
       * the document while remaining off-screen on lower page sections.
       */
      const originMarker = document.createComment("tda-desktop-menu-origin");

      if (menu.parentNode) {
        menu.parentNode.insertBefore(originMarker, menu);
      }

      menu.dataset.tdaMenuPortalled = "true";
      document.body.appendChild(menu);

      const originalToggleLabel = toggle.getAttribute("aria-label") || "Menu";

      const desktopMedia = window.matchMedia(DESKTOP_QUERY);

      let closeTimer;
      let panelTimer;
      let returnTimer;
      let focusTimer;
      let activeIndex = null;
      let activeTrigger = null;

      function motionIsReduced() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      }

      function clearTimers() {
        window.clearTimeout(closeTimer);
        window.clearTimeout(panelTimer);
        window.clearTimeout(returnTimer);
        window.clearTimeout(focusTimer);
      }

      function setDocumentOpenState(isOpen) {
        const html = document.documentElement;
        const body = document.body;

        html.classList.toggle("tda-desktop-menu-open", isOpen);
        body.classList.toggle("tda-desktop-menu-open", isOpen);

        if (isOpen) {
          body.classList.remove("tda-scroll-controls-hidden");
          body.classList.add("tda-global-header-interaction-active");
        } else {
          const anotherHeaderInteractionIsOpen =
            html.classList.contains("tda-search-sheet-open") ||
            Boolean(document.querySelector("header-drawer details[open]"));

          if (!anotherHeaderInteractionIsOpen) {
            body.classList.remove("tda-global-header-interaction-active");
          }
        }

        window.dispatchEvent(
          new CustomEvent("tda:desktop-menu-state", {
            detail: { open: isOpen },
          }),
        );
      }

      function setMainViewHidden(isHidden) {
        if (!mainView) return;
        mainView.setAttribute("aria-hidden", String(isHidden));
      }

      function resetPanelState() {
        window.clearTimeout(panelTimer);
        window.clearTimeout(returnTimer);

        menu.classList.remove("is-expanded", "is-returning");
        delete menu.dataset.tdaImageColumns;
        delete menu.dataset.tdaCardCount;
        activeIndex = null;
        activeTrigger = null;
        setMainViewHidden(false);

        panelButtons.forEach((button) => {
          button.setAttribute("aria-expanded", "false");
        });

        panels.forEach((panel) => {
          panel.classList.remove("is-active", "is-revealed");
          panel.setAttribute("aria-hidden", "true");
        });

        submenus.forEach((submenu) => {
          submenu.classList.remove("is-active");
          submenu.setAttribute("aria-hidden", "true");
        });

        if (rightColumn) rightColumn.scrollTop = 0;
      }

      function openMenu() {
        if (!desktopMedia.matches) return;

        clearTimers();
        resetPanelState();

        menu.setAttribute("open", "");
        menu.classList.remove("is-closing", "is-returning");
        menu.classList.add("is-open");
        setDocumentOpenState(true);
        toggle.setAttribute("aria-expanded", "true");
        toggle.setAttribute("aria-label", "Close menu");

        focusTimer = window.setTimeout(
          () => toggle.focus({ preventScroll: true }),
          motionIsReduced() ? 0 : 360,
        );
      }

      function finishClosing({ restoreFocus = true } = {}) {
        resetPanelState();
        menu.removeAttribute("open");
        menu.classList.remove("is-open", "is-closing");
        setDocumentOpenState(false);
        toggle.setAttribute("aria-expanded", "false");
        toggle.setAttribute("aria-label", originalToggleLabel);

        if (restoreFocus && desktopMedia.matches) {
          toggle.focus({ preventScroll: true });
        }
      }

      function closeMenu(options = {}) {
        if (!menu.hasAttribute("open")) return;
        if (menu.classList.contains("is-closing")) return;

        clearTimers();
        menu.classList.add("is-closing");
        menu.classList.remove("is-open", "is-returning");

        closeTimer = window.setTimeout(
          () => finishClosing(options),
          motionIsReduced() ? 0 : CLOSE_DURATION,
        );
      }

      function warmPanelImages(panel) {
        panel.querySelectorAll("img").forEach((image) => {
          image.loading = "eager";
        });
      }

      function activatePanel(index, trigger) {
        if (!menu.hasAttribute("open")) return;
        if (menu.classList.contains("is-closing")) return;

        const panel = panels.find(
          (item) => item.dataset.tdaMenuPanel === index,
        );
        const submenu = submenus.find(
          (item) => item.dataset.tdaMenuSubmenu === index,
        );

        if (!panel || !submenu) return;
        if (activeIndex === index && menu.classList.contains("is-expanded")) {
          return;
        }

        const wasExpanded = menu.classList.contains("is-expanded");
        const cards = panel.querySelector(
          ".tda-rolex-desktop-menu__cards[data-card-count]",
        );
        const cardCount = cards
          ? Number.parseInt(cards.dataset.cardCount || "0", 10)
          : 0;
        const imageColumns = cardCount >= 4 ? 2 : cardCount > 0 ? 1 : 0;

        menu.dataset.tdaImageColumns = String(imageColumns);
        menu.dataset.tdaCardCount = String(cardCount);

        window.clearTimeout(panelTimer);
        window.clearTimeout(returnTimer);
        window.clearTimeout(focusTimer);
        menu.classList.remove("is-returning");

        panelButtons.forEach((button) => {
          button.setAttribute("aria-expanded", String(button === trigger));
        });

        panels.forEach((item) => {
          item.classList.remove("is-active", "is-revealed");
          item.setAttribute("aria-hidden", "true");
        });

        submenus.forEach((item) => {
          item.classList.remove("is-active");
          item.setAttribute("aria-hidden", "true");
        });

        panel.classList.add("is-active");
        panel.setAttribute("aria-hidden", "false");
        submenu.classList.add("is-active");
        submenu.setAttribute("aria-hidden", "false");
        setMainViewHidden(true);

        activeIndex = index;
        activeTrigger = trigger;
        if (rightColumn) rightColumn.scrollTop = 0;

        warmPanelImages(panel);
        menu.classList.add("is-expanded");

        panelTimer = window.setTimeout(
          () => {
            if (
              activeIndex === index &&
              menu.classList.contains("is-expanded") &&
              !menu.classList.contains("is-closing")
            ) {
              panel.classList.add("is-revealed");
            }
          },
          motionIsReduced() ? 0 : wasExpanded ? 90 : PANEL_REVEAL_DELAY,
        );

        focusTimer = window.setTimeout(
          () => {
            const backButton = submenu.querySelector("[data-tda-menu-back]");
            if (backButton && activeIndex === index) {
              backButton.focus({ preventScroll: true });
            }
          },
          motionIsReduced() ? 0 : wasExpanded ? 120 : 460,
        );
      }

      function returnToMain() {
        if (!menu.classList.contains("is-expanded")) return;

        window.clearTimeout(panelTimer);
        window.clearTimeout(returnTimer);
        window.clearTimeout(focusTimer);

        const triggerToRestore = activeTrigger;

        panelButtons.forEach((button) => {
          button.setAttribute("aria-expanded", "false");
        });

        submenus.forEach((submenu) => {
          submenu.setAttribute("aria-hidden", "true");
        });

        panels.forEach((panel) => {
          panel.setAttribute("aria-hidden", "true");
        });

        setMainViewHidden(false);
        menu.classList.add("is-returning");
        menu.classList.remove("is-expanded");

        if (triggerToRestore) {
          requestAnimationFrame(() => {
            triggerToRestore.focus({ preventScroll: true });
          });
        }

        returnTimer = window.setTimeout(
          () => {
            panels.forEach((panel) => {
              panel.classList.remove("is-active", "is-revealed");
              panel.setAttribute("aria-hidden", "true");
            });

            submenus.forEach((submenu) => {
              submenu.classList.remove("is-active");
            });

            menu.classList.remove("is-returning");
            activeIndex = null;
            activeTrigger = null;
            if (rightColumn) rightColumn.scrollTop = 0;
          },
          motionIsReduced() ? 0 : PANEL_DURATION,
        );
      }

      function visibleFocusableElements() {
        return [toggle].concat(Array.from(
          sheet.querySelectorAll(
            'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])',
          ),
        )).filter((element) => {
          return (
            element.getClientRects().length > 0 &&
            element.getAttribute("aria-hidden") !== "true" &&
            !element.closest('[aria-hidden="true"]')
          );
        });
      }

      function trapFocus(event) {
        if (event.key !== "Tab") return;
        if (!menu.hasAttribute("open")) return;

        const focusable = visibleFocusableElements();
        if (focusable.length === 0) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      toggle.addEventListener("click", (event) => {
        if (!desktopMedia.matches) return;

        event.preventDefault();
        event.stopPropagation();

        if (
          menu.hasAttribute("open") &&
          !menu.classList.contains("is-closing")
        ) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      panelButtons.forEach((button) => {
        button.addEventListener("click", () => {
          activatePanel(button.dataset.tdaMenuOpenPanel, button);
        });
      });

      backButtons.forEach((button) => {
        button.addEventListener("click", returnToMain);
      });

      overlay.addEventListener("click", (event) => {
        if (event.target === overlay) closeMenu();
      });

      document.addEventListener("keydown", (event) => {
        if (!menu.hasAttribute("open")) return;

        if (event.key === "Escape") {
          event.preventDefault();
          closeMenu();
          return;
        }

        trapFocus(event);
      });

      const handleViewportChange = (event) => {
        if (event.matches) return;

        clearTimers();

        if (menu.hasAttribute("open")) {
          finishClosing({ restoreFocus: false });
        } else {
          setDocumentOpenState(false);
        }
      };

      if (typeof desktopMedia.addEventListener === "function") {
        desktopMedia.addEventListener("change", handleViewportChange);
      } else {
        desktopMedia.addListener(handleViewportChange);
      }

      document.addEventListener("shopify:section:unload", (event) => {
        if (
          !event.target.contains(originMarker) &&
          !event.target.contains(menu)
        ) {
          return;
        }

        clearTimers();

        if (menu.hasAttribute("open")) {
          finishClosing({ restoreFocus: false });
        }

        menu.remove();
        originMarker.remove();
      });
    });
  }

  function start() {
    initialiseLvMenu();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initialiseLvMenu(event.target);
  });
})();
